import AbstractInstaller from "../core/application/AbstractInstaller";
import MediatorMapping from "../core/application/MediatorMapping";
import ScormCommand from "./controller/ScormCommand";
import ScormController from "./controller/ScormController";
import ScormEvent from "./events/ScormEvent";
import InitializeScormTask from "./tasks/InitializeScormTask";

export default class ScormInstaller extends AbstractInstaller {
    /**
     * @param {infuse.Injector} injector 
     * @param {soma.Commands} commands 
     * @param {MediatorMapping} mediatorMap 
     */
    constructor(injector, commands, mediatorMap) {
        super(injector, commands, mediatorMap);

        injector.mapClass("scormController", ScormController, true);

        commands.add(ScormEvent.START_SESSION, ScormCommand);
        commands.add(ScormEvent.END_SESSION, ScormCommand);

        this._addStartupTask(InitializeScormTask);

        this._addDestroyEvents([ScormEvent.END_SESSION]);
    }
}